module.exports = __webpack_public_path__ + "img/135.a8c7909c.jpg";